import React, {useState} from 'react';
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Divider, DialogActions, MenuItem, Card, Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../../config/design/styles";
import Grid from "@mui/material/Grid2";
import {useSnackbar} from "notistack";
import LoadingButton from "../../../../components/elements/LoadingButton";
import axios from "axios";
import {defaultVariables} from "../../../../../config";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import AppCardLoaderFields from "../../../../components/loaders/AppCardLoaderFields";
import RayaField from "../../../../components/elements/fields/RayaField";
import {PlusCircle, RefreshCcw} from "lucide-react";
import SubTitle from "../../../../components/elements/SubTitle";
import {
    calcStockPrice,
    currencySymbol,
    price
} from "../../../../../config/values";
import UserChooser from "../../../../components/elements/fields/UserChooser";
import {AddBox} from "@mui/icons-material";
import {useIsSmall} from "../../../../../config/hooks/useWindowDimensions";

const AddStockButton = ({ classes,reload,item_id }) => {
    const [open, setOpen] = useState(false);
    const navigation = useNavigate();
    const { t } = useTranslation();

    const initFields = {
        stock_type: 'normal',
        number_of_stocks: 1,
        is_installmental: 0,
        is_complete: 1,
        bs_number:'',
    };
    const [fields, setFields] = useState(initFields);
    const [errors, setErrors] = useState({});
    const [file, setFile] = useState(null);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [user_id, setUserId] = useState(null);
    const isSmall = useIsSmall();
    const loginToken = localStorage.getItem('ACT');
    const handleChange = (e) => {
        let { name, value } = e.target;
        setFields((prevFields) => ({ ...prevFields, [name]: value }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };
    const handleField = (input,val) => {
        setFields((prevFields) => ({ ...prevFields, [input] : val }));
        setErrors((prevErrors) => ({ ...prevErrors, [input]: '' }));

    };
    const resetFields = () => {
        setFields(initFields);
        setFile(null);
    }
    const closeDialog = () => {
        setOpen(false);
        if(!item_id){
            setTimeout(() => {
                resetFields();
            }, 300);
        }

    }
    const handleValidation = async (callback) => {
        let formIsValid = true;
        let newErrors = {};

        if(!user_id){
            formIsValid = false;
            newErrors.user = t('emptyField');
        }
        if(!fields.bs_number){
            formIsValid = false;
            newErrors.bs_number = t('emptyField');
        }
        setErrors(newErrors);
        if (!formIsValid) setSubmitLoading(false);
        callback(formIsValid);
    };

    const handleRequest = async () => {

        const data = new FormData();
        data.append('stock_type', fields.stock_type);
        data.append('number_of_stocks', fields.number_of_stocks);
        data.append('bs_number', fields.bs_number);
        data.append('is_installmental', !!fields.is_installmental ? 1 : 0);
        data.append('is_complete', !!fields.is_complete ? 1 : 0);
        data.append('user_id', user_id);

        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            const response = await axios.post(`${defaultVariables.url}/stocks/assign`, data, config);
            reload();
            setSubmitLoading(false);
            closeDialog();
            enqueueSnackbar(t('detailsSet'), { variant: 'success' });

        } catch (error) {
            console.error(error.response);
            setSubmitLoading(false);
            if(error.response.status === 403){
                enqueueSnackbar(t('duplicateItemName'), { variant: 'warning' });
            }else{
                enqueueSnackbar(t('detailsSetFailed'), { variant: 'error' });

            }
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitLoading(true);
        handleValidation((valid) => {
            if (valid) handleRequest();
        });
    };
    return (
        <>
            <Button
                variant="contained"
                color="secondary"
                onClick={() => setOpen(!open)}
                startIcon={<AddBox/>}
            >
                {t('assignStock')}
            </Button>


            <Dialog
                fullWidth
                maxWidth={'sm'}
                open={open}
                onClose={() => closeDialog()}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle className='dialog-title' id="form-dialog-title">
                    {t('assignStock')}
                    <IconButton aria-label="close" className={classes.dialogClose} onClick={() => closeDialog()}>
                        <CloseIcon/>
                    </IconButton>
                </DialogTitle>
                <Divider/>
                <DialogContent className="dialog-add-match">
                    <Grid container spacing={2}>
                        {
                            !!loading ?
                                <Grid item size={12}>
                                    <AppCardLoaderFields height={300}/>
                                </Grid>
                                    :
                                <>
                                    <Grid item size={{xs:12,md:6}}>
                                        <UserChooser
                                            handleRes={(user) => !!user && setUserId(user.id)}
                                            default_id={user_id}
                                            error={errors['user']}
                                        />
                                    </Grid>
                                    <Grid item size={{xs:12,md:6}}>
                                        <RayaField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            label={t('stock_type')}
                                            name="stock_type"
                                            value={fields.stock_type}
                                            onChange={handleChange}
                                            error={!!errors.stock_type}
                                            helperText={errors.stock_type}
                                            select
                                        >
                                            <MenuItem value="normal">{t('normalStock')}</MenuItem>
                                            <MenuItem value="special">{t('specialStock')}</MenuItem>
                                        </RayaField>
                                    </Grid>
                                    <Grid item size={{xs:12,md:6}}>
                                        <RayaField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            label={t('is_complete')}
                                            name="is_complete"
                                            value={fields.is_complete}
                                            onChange={handleChange}
                                            error={!!errors.is_complete}
                                            helperText={errors.is_complete}
                                            select
                                        >
                                            <MenuItem value={1}>{t('yesComplete')}</MenuItem>
                                            <MenuItem value={0}>{t('noComplete')}</MenuItem>
                                        </RayaField>
                                    </Grid>
                                    <Grid item size={{xs:12,md:6}}>
                                        <RayaField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            label={t('number_of_stocks')}
                                            name="number_of_stocks"
                                            value={fields.number_of_stocks}
                                            onChange={handleChange}
                                            error={!!errors.number_of_stocks}
                                            helperText={errors.number_of_stocks}
                                            select
                                        >
                                            <MenuItem value={1}>1</MenuItem>
                                            <MenuItem value={2}>2</MenuItem>
                                            <MenuItem value={3}>3</MenuItem>
                                            <MenuItem value={4}>4</MenuItem>
                                            <MenuItem value={5}>5</MenuItem>
                                            <MenuItem value={6}>6</MenuItem>
                                            <MenuItem value={7}>7</MenuItem>
                                            <MenuItem value={8}>8</MenuItem>
                                            <MenuItem value={9}>9</MenuItem>
                                            <MenuItem value={10}>10</MenuItem>
                                        </RayaField>
                                    </Grid>
                                    <Grid item size={{xs:12,md:6}}>
                                        <RayaField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            label={t('is_installmental')}
                                            name="is_installmental"
                                            value={fields.is_installmental}
                                            onChange={handleChange}
                                            error={!!errors.is_installmental}
                                            helperText={errors.is_installmental}
                                            select
                                        >
                                            <MenuItem value={0}>{t('no')}</MenuItem>
                                            <MenuItem value={1}>{t('yes')}</MenuItem>
                                        </RayaField>
                                    </Grid>
                                    <Grid item size={{xs:12,md:6}}>
                                        <RayaField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            label={t('bsNumber')}
                                            name="bs_number"
                                            value={fields.bs_number}
                                            onChange={handleChange}
                                            error={!!errors.bs_number}
                                            helperText={errors.bs_number}
                                        />
                                    </Grid>
                                    <Grid item size={{xs:12}}>
                                        <Box className="bg-red-box flex-space flex-column-md justify-md-center align-items-md-center">
                                            <SubTitle>{t('currentPriceBasedOnThis')}</SubTitle>
                                            <strong style={{fontSize:20}}>
                                                {price(calcStockPrice(fields.stock_type,fields.number_of_stocks,fields.is_complete))} {currencySymbol}
                                            </strong>
                                        </Box>
                                    </Grid>
                                </>
                        }

                    </Grid>
                </DialogContent>
                <DialogActions style={{display:"flex",justifyContent:"center"}}>
                        <LoadingButton
                            variant="contained"
                            color="secondary"
                            onClick={handleSubmit}
                            loading={submitLoading}
                        >
                            {t('assignStock')}
                        </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default withStyles(Styles)(AddStockButton);
